import { createFileRoute } from '@tanstack/react-router'
import { CreateConditionPage } from '_/features/pets/ui/pages/create-condition-page'

const CreateConditionRoute = () => {
	const { petId } = Route.useParams()
	return <CreateConditionPage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/conditions/create')({
	staticData: { title: 'conditions_create_title' },
	component: CreateConditionRoute,
})
